module.exports = __webpack_public_path__ + "static/4-57afd5a1a8a229e6b38f9e7df463fedf.gif";